export const resizeHelper = (sizeUpdater: any, boardContainer: any, app: any) => {
    // near.width = window.innerWidth
    // near.height = window.innerHeight
    // far.width = window.innerWidth
    // far.height = window.innerHeight
    sizeUpdater(window.innerWidth, window.innerHeight)

    let scale = window.innerHeight > 667 ? 1 : window.innerHeight / 667
    boardContainer.x = window.innerWidth / 2
    boardContainer.y = window.innerHeight / 2 - (100 * scale);
    boardContainer.scale.set(scale);
    app.renderer.resize(window.innerWidth, window.innerHeight);
}